<div
  class="register-view"
  [style.background]="'url(/assets/images/' + background + ')'"
  [style.background-size]="'cover'"
>
  <div class="register-banner">
    <img src="/assets/images/line-sim-icon-144.png" height="48" style="display: inline-block; margin-top: -16px; margin-right: 24px;"/>
    <h2 style="display: inline-block; margin-top: 12px;">Project Manager</h2>
  </div>
  <div
    class="register-form"
  >

<h2>Register</h2>

<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

  <div class="form-group">
    <label for="firstName">First Name<span style="color: red; vertical-align: super; font-size: smaller;">*</span></label>
    <input type="text" id="firstName" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
      <div *ngIf="f.firstName.errors.required">First Name is required</div>
    </div>
  </div>

  <div class="form-group">
    <label for="lastName">Last Name<span style="color: red; vertical-align: super; font-size: smaller;">*</span></label>
    <input type="text" id="lastName" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
      <div *ngIf="f.lastName.errors.required">Last Name is required</div>
    </div>
  </div>

  <div class="form-group">
    <label for="email">eMail<span style="color: red; vertical-align: super; font-size: smaller;">*</span></label>
    <input type="text" id="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
      <div *ngIf="f.email.errors.required">eMail is required</div>
      <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
    </div>
  </div>

  <div class="form-group">
    <label for="username">Username<span style="color: red; vertical-align: super; font-size: smaller;">*</span></label>
    <input type="text" id="username" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
      <div *ngIf="f.username.errors.required">Username is required</div>
    </div>
  </div>

  <div class="form-group">
    <label for="password">Password<span style="color: red; vertical-align: super; font-size: smaller;">*</span></label>
    <input type="password" id="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
      <div *ngIf="f.password.errors.required">Password is required</div>
      <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
    </div>
  </div>

  <div class="form-group">

    <button [disabled]="loading" class="btn btn-danger">Register</button>

    <div  *ngIf="loading" class="fa-lg" style="display: inline-block; margin-left: 8px;">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>

    <a routerLink="/login" class="btn btn-link">Cancel</a>

  </div>

</form>

</div>

</div>
